import { toast } from 'react-toastify';
import { z } from 'zod';

type AsyncCallbackFn<T> = (args?: any) => Promise<T>;

export const asyncErrorHandler = <T>(asyncFn: AsyncCallbackFn<T>): (() => Promise<T>) => {
  return async () => {
    try {
      return await asyncFn();
    } catch (error: unknown) {
      if (error instanceof z.ZodError) {
        console.log(error.message);
        toast.error('API validation failed');
      }
      if (error instanceof Error) console.log(error.message);
      return Promise.reject(error);
    }
  };
};
